import React from 'react'
import { ThemeColor, Categories } from '@/enums'
import { Info } from '@/icons'
import { useParams } from 'react-router-dom'
import { Column, Row, Typography } from '../../../components'
import { InsuranceCustomBaseView } from './InsuranceCustomBaseView'
import { useTranslation } from 'react-i18next'

interface InfoItem {
  title: string
  description: string
}

interface InfoContentProps {
  info: InfoItem[]
}

const InfoContent = ({ info }: InfoContentProps) => (
  <Column gap="30px">
    {info.map((item, index) => (
      <Row key={index} gap="16px">
        <Typography singleLine variant="captionR">
          <Info
            color={ThemeColor.b50}
            cursor="pointer"
            fill="none"
            size="menu"
            stroke
          />
        </Typography>

        <Row>
          <Column gap="8px">
            <Typography singleLine variant="p1Body">
              {item.title}
            </Typography>
            <Typography color={ThemeColor.b50} variant="p2Body">
              {item.description}
            </Typography>
          </Column>
        </Row>
      </Row>
    ))}
  </Column>
)

export const PrivatePensionInsuranceView: React.FC = () => {
  const { t } = useTranslation()
  const { categoryId } = useParams<{ categoryId: keyof typeof Categories }>()

  if (!categoryId) {
    return null
  }

  const infoContent = t(
    `insuranceFinderTranslations.insuranceFinderViews.${Categories[categoryId].key}`,
  ) as InfoItem[]

  return (
    <InsuranceCustomBaseView
      popoverContent={<InfoContent info={infoContent} />}
    />
  )
}
